import { CompanyLogo, HeaderLogo } from "../../../styles/component/style";
import { Images } from "../../../assets/images";
import styled, { css } from "styled-components";
import {
  LogoContainer,
  LinksContainer,
  ProfileImage,
  LogoutText,
  BigScreen,
  SmallScreenMenu,
  SmallScreen,
  Row,
  H2,
  ImageContainer,
  RightLogoContainer,
} from "./Styles";
import React, { useContext, useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import COLORS from "../../../assets/Colors";
import _ from "lodash";
import { navigate, useLocation } from "@reach/router";
import labels from "../../../helpers/labels.json";
import useAlert from "../../../hooks/useAlert";
import { scroller } from "react-scroll";
import { TranslaterContext } from "../../../providers/TranslaterProvider";
import DropDownMenu from "../../common/DropDownMenu";
import TemporaryDrawer from "./Drawer";
import useViewer from "../../../hooks/useViewer";
import AuthService from "../../../services/AuthService";
import moment from "moment";
import { useSnackbar } from "notistack";
import { getErrorMessage } from "../../../helpers/functions";

const EXCLUDE_URL = ["create-profile"];

const useStyles = makeStyles((theme) => ({
  // appBar: {
  //   zIndex: theme.zIndex.drawer + 1,
  //   background: "transparent",
  //   boxShadow: "none",
  //   height: 125,
  //   display: "flex",
  //   alignItems: "center",
  // },
  // appBar: {
  //   zIndex: theme.zIndex.drawer + 1,
  //   background: "transparent",
  //   boxShadow: "none",

  //   height: 125,

  //   display: "flex",
  //   alignItems: "center",

  //   "@media (max-width: 600px) and (orientation: portrait)": {
  //     height: "25%",
  //   },
  // },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    background: "transparent",
    boxShadow: "none",

    height: 125,

    display: "flex",
    alignItems: "center",

    "@media (max-width: 600px) and (orientation: portrait)": {
      height: "25%",
    },

    "@media (max-width: 900px) and (orientation: landscape)": {
      position: "relative",
      flexShrink: 0,
    },
  },

  appSpacedBar: {
    zIndex: theme.zIndex.drawer + 1,
    background: "transparent",
    boxShadow: "none",
    minHeight: 150,
    display: "flex",
    justifyContent: "center",
    marginTop: 40,
  },
  /*
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    background: COLORS.PRIMARY_WHITE,
    height: 125,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    boxShadow: "none",
    borderBottom: "1px solid #e1e3ee",
  },
  */
  // toolbar: {
  //   width: "100%",
  //   maxWidth: "1800px",
  //   margin: "0 auto",

  //   display: "grid",
  //   gridTemplateColumns: "220px 1fr 220px",

  //   alignItems: "center",

  //   padding: "0 16px",

  //   columnGap: 20,

  //   [theme.breakpoints.down("md")]: {
  //     gridTemplateColumns: "170px 1fr 170px",
  //     padding: "0 12px",
  //   },

  //   [theme.breakpoints.down("sm")]: {
  //     gridTemplateColumns: "100px 1fr 100px",
  //     padding: "0 8px",
  //     columnGap: 8,
  //   },
  // },
  toolbar: {
    width: "100%",
    maxWidth: "1800px",
    margin: "0 auto",

    display: "grid",
    gridTemplateColumns: "220px minmax(0, 1fr) 220px",

    alignItems: "center",

    padding: "0 16px",
    columnGap: 20,

    [theme.breakpoints.down("md")]: {
      gridTemplateColumns: "170px minmax(0, 1fr) 170px",
      padding: "0 12px",
    },

    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "100px minmax(0, 1fr) 100px",
      padding: "0 8px",
      columnGap: 8,
    },

    "@media (max-width: 600px) and (orientation: portrait)": {
      height: "100%",

      gridTemplateColumns: "1fr 1fr",
      gridTemplateRows: "30% 70%",

      padding: "8px 12px",

      columnGap: 12,

      alignItems: "center",

      boxSizing: "border-box",
    },
  },
  leftLogo: {
    minWidth: 0,

    "@media (max-width: 600px) and (orientation: portrait)": {
      gridColumn: "1",
      gridRow: "1",

      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",

      padding: "4px 0 !important",
    },
  },

  eventInformation: {
    minWidth: 0,

    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",

    "@media (max-width: 600px) and (orientation: portrait)": {
      gridColumn: "1 / -1",
      gridRow: "2",

      width: "100%",
      height: "100%",

      padding: "4px 8px",

      boxSizing: "border-box",
      transform: "scale(0.7)",
    },
  },

  rightLogo: {
    minWidth: 0,

    "@media (max-width: 600px) and (orientation: portrait)": {
      gridColumn: "2",
      gridRow: "1",

      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",

      width: "100%",
      height: "100%",
      minWidth: 0,
      minHeight: 0,

      padding: "4px 0 !important",
      overflow: "hidden",
    },
  },
  /*
  appSpacedBar: {
    zIndex: theme.zIndex.drawer + 1,
    background: COLORS.PRIMARY_WHITE,
    minHeight: 150,
    display: "flex",
    justifyContent: "center",
    borderBottom: "1px solid #d9d9d9",
    boxShadow: "0 6px 18px rgba(0,0,0,.08)",
    marginTop: 40,
    padding: "12px 40px",
    boxSizing: "border-box",

    [theme.breakpoints.down("sm")]: {
      padding: "10px 16px",
      minHeight: 110,
    },
    [theme.breakpoints.down("xs")]: {
      padding: "8px 10px",
      minHeight: 95,
    },
  },
  */
}));

export default function StyledAppBar({
  NavPages,
  hideLinks,
  LandingPage,
  ArbitPages,
  cartCount,
  setShowDrawer,
  stats,
  hideIcon,
  password,
  showDrawer,
}) {
  const { userObject, globalState, setGlobalState, setUserObject } =
    useViewer();
  const { showAlert, hideAlert } = useAlert();
  const { translaterOpen } = useContext(TranslaterContext);
  const location = useLocation();
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  const appBarRef = useRef(null);

  useEffect(() => {
    const el = appBarRef.current;
    if (!el) return;

    const publishHeight = () => {
      document.documentElement.style.setProperty(
        "--agm-header-height",
        `${el.offsetHeight}px`,
      );
    };

    publishHeight();

    const resizeObserver = new ResizeObserver(publishHeight);
    resizeObserver.observe(el);
    window.addEventListener("resize", publishHeight);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener("resize", publishHeight);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [globalState?.theme?.themeHeader, translaterOpen]);

  async function viewerLogout(viewerId, role) {
    try {
      const payload = {
        logoutTime: moment(new Date()).format("HH:mm"),
        role: role,
      };
      const eventId = userObject?.eventId;
      const response = await AuthService.viewerLogout(viewerId, payload);
      if (response?.status) {
        enqueueSnackbar("Logout successfully", {
          variant: "success",
        });
        localStorage.removeItem("auth_token");
        localStorage.removeItem("role");
        localStorage.removeItem("pollArray");
        localStorage.removeItem("dsnl_cookies_enabled");
        navigate(`/events/login?eventId=${eventId}`);
        setGlobalState({ customTab: [] });
        setUserObject({});
        // setToken("logged_out");
      }
    } catch (error) {
      const message = getErrorMessage(error);
      enqueueSnackbar(message, {
        variant: "error",
      });
    } finally {
      hideAlert();
    }
  }

  const handleLogout = () => {
    showAlert({
      heading: "Logout?",
      desc: "Are you sure you want to logout?",
      primaryBtnText: "Logout",
      secondaryBtnText: "Cancel",
      clickSecondarybtn: () => hideAlert(),
      clickPrimaryBtn: () => {
        viewerLogout(userObject?.viewerId, "eventViewer");
      },
      isOpen: true,
      onDialogClose: () => hideAlert(),
    });
  };

  /**
   * @description after login inputs
   */

  const after_login_inputs = [
    {
      name: "Home",
      link: "/live#home",
    },
    {
      name: "Agenda",
      link: "#agenda",
      section: "agenda",
      hidden:
        globalState?.event?.speakerSection?.speakersRequired &&
        globalState?.event?.eventSettings?.userViewInsidePage
          ? false
          : true,
    },
    {
      name: "Speakers",
      link: "#speakers",
      section: "speakers",
      hidden:
        globalState?.event?.speakerSection?.speakersRequired &&
        globalState?.event?.eventSettings?.userViewInsidePage
          ? false
          : true,
    },
    {
      name: "Resources",
      link: "#resources",
      section: "resources",
      hidden:
        globalState?.event?.resourceSection?.resourcesRequired &&
        globalState?.event?.eventSettings?.userViewInsidePage
          ? false
          : true,
    },
    {
      name: "Videos",
      link: "#videos",
      section: "videos",
      hidden:
        globalState?.event?.resourceSection?.resourcesRequired &&
        globalState?.event?.eventSettings?.userViewInsidePage
          ? false
          : true,
    },
    {
      name: "Polling",
      link: "#polling",
      section: "polling",
      hidden: globalState?.livepage?.livePageSettings?.livePoll ? false : true,
    },
    {
      name: globalState?.livepage?.livePageSettings?.generalGuidelinesLabel
        ? globalState?.livepage?.livePageSettings?.generalGuidelinesLabel
        : "General Guidelines Tab",
      link: "#general-guidelines-tab",
      section: "#general-guidelines-tab",
      hidden: globalState?.livepage?.livePageSettings?.generalGuidelines
        ? false
        : true,
    },
    {
      name: "FAQs",
      link: "/live#faqs",
      section: "faqs",
    },
    {
      name: "Help",
      link: "#help",
    },
    {
      name: "Feedback",
      link: "/live#feedback",
      section: "feedback",
      hidden:
        globalState?.feedback?.feedbackForm &&
        Object.keys(globalState.feedback.feedbackForm).length !== 0
          ? false
          : true,
    },
  ];

  /**
   * @before login inputs
   */

  const before_login_inputs = [
    {
      name: "Home",
      link: `${location.href.split("#")[0]}#home`,
      section: "about",
    },
    {
      name: "Agenda",
      link: `#agenda`,
      section: "agenda",
      hidden:
        globalState?.speakerSection?.speakersRequired &&
        globalState?.eventSettings?.userViewInsidePage
          ? false
          : true,
    },
    {
      name: "Speakers",
      link: `#speakers`,
      section: "speakers",
      hidden:
        globalState?.speakerSection?.speakersRequired &&
        globalState?.eventSettings?.userViewInsidePage
          ? false
          : true,
    },
    {
      name: "Resources",
      link: `#resources`,
      section: "resources",
      hidden:
        globalState?.resourceSection?.resourcesRequired &&
        globalState?.eventSettings?.userViewInsidePage
          ? false
          : true,
    },
    {
      name: "Videos",
      link: `#videos`,
      section: "videos",
      hidden:
        globalState?.resourceSection?.resourcesRequired &&
        globalState?.eventSettings?.userViewInsidePage
          ? false
          : true,
    },
    {
      name: globalState?.livePageSettings?.generalGuidelinesLabel
        ? globalState?.livePageSettings?.generalGuidelinesLabel
        : "General Guidelines Tab",
      link: "#general-guidelines-tab",
      hidden: globalState?.livePageSettings?.generalGuidelines ? false : true,
    },
    {
      name: "FAQs",
      link: `#faqs`,
      section: "faqs",
    },
    {
      name: "Help",
      link: "#help",
    },
  ];
  const underlineThickness =
    Number(globalState?.theme?.themeHeader?.headerUnderlineThickness) || 1;

  const underlineColor =
    globalState?.theme?.themeHeader?.headerUnderlineColor || "#a0932c";

  const bodyBgImage = globalState?.theme?.themeGeneral?.backgroundImage;
  const bodyBgColor = globalState?.theme?.themeGeneral?.bodyBackgroundColor;

  const appBarStyle = {
    background: bodyBgImage ? "transparent" : bodyBgColor || "#ffffff",

    backgroundColor: bodyBgImage ? "transparent" : bodyBgColor || "#ffffff",

    backgroundImage: "none",

    boxShadow: bodyBgImage ? "none" : "0 6px 18px rgba(0,0,0,.08)",

    borderBottom: bodyBgImage
      ? `${underlineThickness}px solid ${underlineColor}`//"none"
      :  `${underlineThickness}px solid ${underlineColor}`,
  };
  return (
    // <AppBar
    //   ref={appBarRef}
    //   position="fixed"
    //   // style={{
    //   //   backgroundRepeat: "repeat",
    //   //   backgroundSize: "160px, 160px",
    //   //   backgroundBlendMode: "overlay",
    //   //   borderBottom: `${underlineThickness}px solid ${underlineColor}`,
    //   //   boxShadow: "0 6px 18px rgba(0,0,0,.08)",
    //   // }}
    //   className={translaterOpen ? classes.appSpacedBar : classes.appBar}
    // >
    <AppBar
      ref={appBarRef}
      position="fixed"
      elevation={0}
      style={appBarStyle}
      className={translaterOpen ? classes.appSpacedBar : classes.appBar}
    >
      <Toolbar className={classes.toolbar}>
        {password === true ? (
          <>
            <LogoContainer
              className={classes.leftLogo}
              style={{
                justifyContent:
                  globalState?.theme?.themeHeader?.logoPlacement === "right"
                    ? "flex-end"
                    : "flex-start",

                paddingLeft: "24px",
                paddingTop: "12px",
                paddingBottom: "12px",

                boxSizing: "border-box",
              }}
            >
              {globalState?.theme?.themeHeader?.logoImage ? (
                <HeaderLogoAppBarNew
                  src={
                    globalState?.theme?.themeHeader?.logoImage
                      ? globalState?.theme?.themeHeader?.logoImage
                      : Images.companyLogo
                  }
                  width={globalState?.theme?.themeHeader?.logoWidth}
                  height={globalState?.theme?.themeHeader?.logoHeight}
                />
              ) : null}
            </LogoContainer>
            <ImageContainer
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                textAlign: "center",
                padding: "0 20px",
                overflow: "hidden",
              }}
            >
              {globalState?.theme?.themeHeader?.eventTitleImage ? (
                <CompanyLogo
                  src={globalState?.theme?.themeHeader?.eventTitleImage}
                />
              ) : (
                <H2
                  style={{
                    color: globalState?.theme?.themeHeader?.eventTitleColor,
                    textShadow: `2px 2px 4px ${globalState?.theme?.themeHeader?.eventTitleShadowColor}`,
                  }}
                >
                  {globalState?.eventTitle}
                </H2>
              )}
            </ImageContainer>
          </>
        ) : (
          <>
            <LogoContainer
              className={classes.leftLogo}
              style={{
                justifyContent:
                  globalState?.theme?.themeHeader?.logoPlacement === "right"
                    ? "flex-end"
                    : "flex-start",

                paddingLeft: "24px",
                paddingTop: "12px",
                paddingBottom: "12px",

                boxSizing: "border-box",
              }}
            >
              {globalState?.theme?.themeHeader?.logoImage ? (
                <HeaderLogoAppBarNew
                  onClick={() =>
                    LandingPage
                      ? scroller.scrollTo("hero", {
                          duration: 500,
                          offset: -70,
                          smooth: true,
                        })
                      : _.isEmpty(userObject)
                        ? ""
                        : navigate("/live")
                  }
                  width={globalState?.theme?.themeHeader?.logoWidth}
                  height={globalState?.theme?.themeHeader?.logoHeight}
                  src={
                    globalState?.theme?.themeHeader?.logoImage
                      ? globalState?.theme?.themeHeader?.logoImage
                      : Images.companyLogo
                  }
                />
              ) : null}
            </LogoContainer>

            
              <div className={classes.eventInformation}>
                <div
                  style={{
                    fontFamily:
                      globalState?.theme?.themeHeader?.eventNameFontFamily,
                    fontSize:
                      globalState?.theme?.themeHeader?.eventNameFontSize,
                    color: globalState?.theme?.themeHeader?.eventNameFontColor,
                    fontWeight: globalState?.theme?.themeHeader?.eventNameBold
                      ? "bold"
                      : "normal",
                    fontStyle: globalState?.theme?.themeHeader?.eventNameItalic
                      ? "italic"
                      : "normal",
                    lineHeight: 1.3,
                  }}
                  dangerouslySetInnerHTML={{
                    __html: (
                      globalState?.theme?.themeHeader?.eventNameText || ""
                    ).replace(/(\d+)(st|nd|rd|th)/g, "$1<sup>$2</sup>"),
                  }}
                />

                <div
                  style={{
                    fontFamily:
                      globalState?.theme?.themeHeader?.companyNameFontFamily,
                    fontSize:
                      globalState?.theme?.themeHeader?.companyNameFontSize,
                    color:
                      globalState?.theme?.themeHeader?.companyNameFontColor,
                    fontWeight: globalState?.theme?.themeHeader?.companyNameBold
                      ? "bold"
                      : "normal",
                    fontStyle: globalState?.theme?.themeHeader
                      ?.companyNameItalic
                      ? "italic"
                      : "normal",
                    lineHeight: 1.3,
                  }}
                >
                  {globalState?.theme?.themeHeader?.companyNameText}
                </div>

                <div
                  style={{
                    fontFamily:
                      globalState?.theme?.themeHeader?.eventWhenFontFamily,
                    fontSize:
                      globalState?.theme?.themeHeader?.eventWhenFontSize,
                    color: globalState?.theme?.themeHeader?.eventWhenFontColor,
                    fontWeight: globalState?.theme?.themeHeader?.eventWhenBold
                      ? "bold"
                      : "normal",
                    fontStyle: globalState?.theme?.themeHeader?.eventWhenItalic
                      ? "italic"
                      : "normal",
                    lineHeight: 1.3,
                  }}
                  dangerouslySetInnerHTML={{
                    __html: (
                      globalState?.theme?.themeHeader?.eventWhenText || ""
                    ).replace(/(\d+)(st|nd|rd|th)/g, "$1<sup>$2</sup>"),
                  }}
                />
              </div>
              
              {globalState?.theme?.themeHeader?.secondaryLogoImage ? (
                <RightLogoContainer
                  className={classes.rightLogo}
                  style={{
                    paddingRight: "24px",
                    paddingTop: "12px",
                    paddingBottom: "12px",
                    boxSizing: "border-box",
                  }}
                >
                  <SecondaryLogo
                    src={globalState?.theme?.themeHeader?.secondaryLogoImage}
                    alt="Secondary Logo"
                    width={globalState?.theme?.themeHeader?.secondaryLogoWidth}
                    height={globalState?.theme?.themeHeader?.secondaryLogoHeight}
                  />
                </RightLogoContainer>
              ) : (
                <div />
              )}
          </>
        )}

        
      </Toolbar>
    </AppBar>
  );
}
const HeaderLogoAppBarNew = styled.img`
  display: block;
  object-fit: contain;
  max-width: 100%;

  width: ${({ width }) => (width ? `${width}px` : "180px")};
  height: ${({ height }) => (height ? `${height}px` : "90px")};

  @media (max-width: 960px) {
    width: 120px;
    height: auto;
  }

  @media (max-width: 600px) {
    width: 80px;
    height: auto;
  }
`;
const SecondaryLogo = styled.img`
  display: block;
  object-fit: contain;

  width: ${({ width }) => (width ? `${width}px` : "180px")};
  height: ${({ height }) => (height ? `${height}px` : "90px")};

  max-width: 100%;

  @media (max-width: 960px) {
    width: 120px;
    height: auto;
  }

  @media (max-width: 600px) and (orientation: portrait) {
    width: auto;
    height: auto;

    max-width: 100%;
    max-height: 100%;
  }
`;